export default "__VITE_ASSET__4Dltl58p__"